import { dashboardService } from "@/api/services/dashboardService";
import { DashboardApiMetricWidget } from "../dashboardLeafWidgets";

type Data = Record<string, any>;

/** 会员营收统计，保留费用总额和会员类型费用字段。 */
export default function MemberRevenueStatistic() {
    return (
        <DashboardApiMetricWidget<Data>
            title="会员营收统计"
            load={value => dashboardService.getMemberRevenueStatistic(value as never)}
            metrics={[
                { label: "基础会员费用", key: "totalBaseMemberCost", unit: "万元" },
                { label: "高级会员费用", key: "totalSeniorMemberCost", unit: "万元" },
                { label: "企业会员费用", key: "totalEnterpriseGradeMemberCost", unit: "万元" }
            ]}
        />
    );
}
